import _ from './lib/underscore_extend';
import $ from 'jquery';
import Backbone from 'backbone';

import Application from './lib/application';

export default Application;

export {
    $,
    _,
    Backbone
}



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/index.js